import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import HowItWorks from "@/components/HowItWorks";
import QuoteForm from "@/components/QuoteForm";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Services />
        <WhyChoose />
        <HowItWorks />
        <QuoteForm />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <ChatWidget />

      {/* SEO — screen-reader-only keyword-rich copy, crawlable but visually hidden */}
      <div className="sr-only" aria-hidden="false">
        <h2>Superstate LLC — Professional Truck Dispatching Service for Owner-Operators and Fleets</h2>
        <p>
          Superstate LLC is a trucking dispatch company serving owner-operators, carriers, and small
          fleets across all 48 contiguous United States. As a professional truck dispatcher and
          freight dispatcher, we find loads, negotiate rates, and handle broker communication so
          truckers can stay focused on driving. Our truck load dispatching services cover dry van
          dispatch, reefer dispatch, flatbed dispatch, step deck, box truck dispatch, and hotshot
          dispatch. We specialize in FTL dispatch service and LTL freight dispatcher work with rate
          confirmation service and full trucking back office support.
        </p>
        <p>
          Looking for a dispatcher who negotiates rates for you? A dispatch service for owner operator
          with no contract? A carrier dispatch service for new authority carriers? Superstate LLC is
          the affordable dispatch service and best truck dispatcher for semi truck owner-operators
          who want to maximize revenue, find more loads, and reduce paperwork. Small fleet dispatch
          service, Southeast truck dispatcher, nationwide dispatch service USA, Midwest freight
          dispatcher — we cover them all.
        </p>
      </div>
    </div>
  );
}
